module.exports = __webpack_public_path__ + "img/1.9ae3a532.png";